import { TSchema } from '@core';
import { TEventInformation } from '@core/events';
import * as apis from '@core/apis';

export const handler = ({
  form,
  formEventDirectives,
}: Pick<TEventInformation<unknown>, 'form' | 'formEventDirectives'>) => {
  formEventDirectives?.visibilityConditions?.forEach((condition) => {
    const fieldNames = [...(condition.fieldNames || [condition.fieldName])];

    fieldNames.forEach((targetFieldName) => {
      if (!targetFieldName) return;

      const field = form.fields[targetFieldName];

      form.fields[targetFieldName].visibility = field?.fieldHasError(
        apis.validations.run(field.value, condition.validations),
      );
      form.fields[targetFieldName].rehydrate();
    });
  });
};

export const events = (schema: TSchema) =>
  Object.keys(schema?.visibilityConditions || {});
